export const Training = () => {
  return (
    <section className="py-14 bg-gray-50 text-center">
      <h2 className="text-4xl font-bold mb-6">Professional Training Programs</h2>

      <p className="text-gray-600 max-w-7xl mx-auto mb-12">
        Our training programs are designed to transform beginners into industry-ready developers.
        We focus on practical learning, real-time project development, and career-oriented skills.
      </p>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">

        <div className="p-8 bg-white rounded-2xl shadow">
          <h3 className="text-xl font-semibold mb-3">MERN Stack Development</h3>
          <p className="text-gray-600">
            Learn MongoDB, Express, React, and Node.js with real-world projects.
            Build full-stack applications from scratch.
          </p>
        </div>

        <div className="p-8 bg-white rounded-2xl shadow">
          <h3 className="text-xl font-semibold mb-3">AI / ML Development</h3>
          <p className="text-gray-600">
            Learn machine learning concepts, data analysis, and AI integration
            using Python and real datasets.
          </p>
        </div>

        <div className="p-8 bg-white rounded-2xl shadow">
          <h3 className="text-xl font-semibold mb-3">UI/UX Design</h3>
          <p className="text-gray-600">
            Master modern design tools and create user-friendly interfaces
            for web and mobile applications.
          </p>
        </div>

      </div>
    </section>
  );
};